var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import GET_SPECIFICATION_PREVIEW_COMPONENTS from 'api/queries/GET_SPECIFICATION_PREVIEW_COMPONENTS';
import GET_SPECIFICATION_PREVIEW_HEADER from 'api/queries/GET_SPECIFICATION_PREVIEW_HEADER';
import GET_SPECIFICATION_PREVIEW_INFO from 'api/queries/GET_SPECIFICATION_PREVIEW_INFO';
import GET_SPECIFICATION_PREVIEW_QUANTITIES from 'api/queries/GET_SPECIFICATION_PREVIEW_QUANTITIES';
import client from '../api/environment';
const initialState = {
    item: null,
    status: {
        fetch: 'idle',
        fetchInfo: 'idle',
        fetchQuantities: 'idle',
        fetchComponents: 'idle',
        fetchConsumptions: 'idle',
        fetchVariants: 'idle',
    },
    error: null,
};
export const fetchSpecificationPreview = createAsyncThunk('components/fetchSpecificationPreview', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ specificationId }, { rejectWithValue }) {
    try {
        const data = yield client.query({
            query: GET_SPECIFICATION_PREVIEW_HEADER,
            variables: { modelSpecificationId: specificationId },
        });
        return data.data.node;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const fetchPreviewInfo = createAsyncThunk('components/fetchPreviewInfo', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ specificationId }, { rejectWithValue }) {
    try {
        const data = yield client.query({
            query: GET_SPECIFICATION_PREVIEW_INFO,
            variables: { modelSpecificationId: specificationId },
        });
        return data.data.node;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const fetchPreviewQuantities = createAsyncThunk('components/fetchPreviewQuantities', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ specificationId }, { rejectWithValue }) {
    try {
        const data = yield client.query({
            query: GET_SPECIFICATION_PREVIEW_QUANTITIES,
            variables: { modelSpecificationId: specificationId },
        });
        return data.data.node;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const fetchPreviewComponents = createAsyncThunk('components/fetchPreviewComponents', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ specificationId }, { rejectWithValue }) {
    try {
        const data = yield client.query({
            query: GET_SPECIFICATION_PREVIEW_COMPONENTS,
            variables: { modelSpecificationId: specificationId },
        });
        return data.data.node;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const fetchPreviewConsumptions = createAsyncThunk('components/fetchPreviewConsumptions', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ specificationId }, { rejectWithValue }) {
    try {
        const data = yield client.query({
            query: GET_SPECIFICATION_PREVIEW_COMPONENTS,
            variables: { modelSpecificationId: specificationId },
        });
        return data.data.node;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const fetchPreviewVariants = createAsyncThunk('components/fetchPreviewVariants', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ specificationId }, { rejectWithValue }) {
    try {
        const data = yield client.query({
            query: GET_SPECIFICATION_PREVIEW_COMPONENTS,
            variables: { modelSpecificationId: specificationId },
        });
        return data.data.node;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
const specificationPreviewSlice = createSlice({
    name: 'specifications',
    initialState,
    reducers: {
        resetSpecificationPreview(state) {
            state.item = null;
            state.status = initialState.status;
            state.error = null;
        },
        addSpecificationPicture(state, action) {
            state.item.image = action.payload;
        },
        removeSpecificationPicture(state) {
            state.item.image = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSpecificationPreview.pending, (state) => {
            state.status.fetch = 'loading';
        })
            .addCase(fetchSpecificationPreview.fulfilled, (state, action) => {
            state.item = Object.assign(Object.assign({}, state.item), action.payload);
            state.status.fetch = 'succeeded';
        })
            .addCase(fetchSpecificationPreview.rejected, (state, action) => {
            state.status.fetch = 'failed';
            state.error = action.payload || 'Failed to fetch specification preview';
        })
            .addCase(fetchPreviewInfo.pending, (state) => {
            state.status.fetchInfo = 'loading';
        })
            .addCase(fetchPreviewInfo.fulfilled, (state, action) => {
            state.item = Object.assign(Object.assign({}, state.item), action.payload);
            state.status.fetchInfo = 'succeeded';
        })
            .addCase(fetchPreviewInfo.rejected, (state) => {
            state.status.fetchInfo = 'failed';
        })
            .addCase(fetchPreviewQuantities.pending, (state) => {
            state.status.fetchQuantities = 'loading';
        })
            .addCase(fetchPreviewQuantities.fulfilled, (state, action) => {
            state.item = Object.assign(Object.assign({}, state.item), action.payload);
            state.status.fetchQuantities = 'succeeded';
        })
            .addCase(fetchPreviewQuantities.rejected, (state) => {
            state.status.fetchQuantities = 'failed';
        })
            .addCase(fetchPreviewComponents.pending, (state) => {
            state.status.fetchComponents = 'loading';
        })
            .addCase(fetchPreviewComponents.fulfilled, (state, action) => {
            state.item = Object.assign(Object.assign({}, state.item), action.payload);
            state.status.fetchComponents = 'succeeded';
        })
            .addCase(fetchPreviewComponents.rejected, (state) => {
            state.status.fetchComponents = 'failed';
        })
            .addCase(fetchPreviewConsumptions.pending, (state) => {
            state.status.fetchConsumptions = 'loading';
        })
            .addCase(fetchPreviewConsumptions.fulfilled, (state, action) => {
            state.item = Object.assign(Object.assign({}, state.item), action.payload);
            state.status.fetchConsumptions = 'succeeded';
        })
            .addCase(fetchPreviewConsumptions.rejected, (state) => {
            state.status.fetchConsumptions = 'failed';
        })
            .addCase(fetchPreviewVariants.pending, (state) => {
            state.status.fetchVariants = 'loading';
        })
            .addCase(fetchPreviewVariants.fulfilled, (state, action) => {
            state.item = Object.assign(Object.assign({}, state.item), action.payload);
            state.status.fetchVariants = 'succeeded';
        })
            .addCase(fetchPreviewVariants.rejected, (state) => {
            state.status.fetchVariants = 'failed';
        });
    },
});
export const { resetSpecificationPreview, addSpecificationPicture, removeSpecificationPicture } = specificationPreviewSlice.actions;
export const selectSpecificationPreviewItem = (state) => state.specificationPreview.item;
export const selectSpecificationPreviewStatus = (state) => state.specificationPreview.status;
export default specificationPreviewSlice.reducer;
